
import { handleFetchResponse, handleFetchError, getHeaders } from './../helpers/api';

const CAR_LIST = '/api/cars/list/<sort>';

const CAR_ASSET = '/api/cars/<id>/asset';

const CAR_DETAIL = '/api/cars/<id>/detail';

const CAR_USER_DETAIL = '/api/cars/<id>/users/<user_id>';

const OPTION_CATEGORY_DETAIL = '/api/cars/option_category/<id>/detail';

const OPTION_GROUP_DETAIL = '/api/cars/option_group/<id>/detail';

const OPTION_DETAIL = '/api/cars/option/<id>/detail';

const CONFIGURATION_DETAIL = '/api/cars/configuration/<id>/detail';

const CONFIGURATION_LIST = '/api/cars/configuration/list';

const BUILD_SHEET = '/api/cars/buildsheet';

export const createBuildSheet = ( data ) => {

    let method = 'POST', headers = getHeaders( method, false ),
    
    body = JSON.stringify( data );

    return fetch( BUILD_SHEET, { method, headers, body } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const getCarsList = ( sort ) => {

    let method = 'GET', headers = getHeaders( method, false );

    return fetch( CAR_LIST.replace( "<sort>", sort ), { method, headers } )
    .then( handleFetchResponse ).catch( handleFetchError );
}
  
export const getCarAsset = ( id ) => {

    let method = 'GET', headers = getHeaders( method, false );

    return fetch( CAR_ASSET.replace( "<id>", id ), { method, headers } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const getCarDetail = ( id ) => {

    let method = 'GET', headers = getHeaders( method, false );

    return fetch( CAR_DETAIL.replace( "<id>", id ), { method, headers } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const postCar = ( title ) => {

    let method = 'POST', headers = getHeaders( method, false ),

    body = JSON.stringify( { title } );

    return fetch( CAR_LIST, { method, headers, body } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const patchCar = ( id, data ) => {

    let method = 'PATCH', headers = getHeaders( method, false ),

    body = JSON.stringify( data );

    return fetch( CAR_DETAIL.replace( "<id>", id ), { method, headers, body } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const patchOption = ( id, data ) => {

    let method = 'PATCH', headers = getHeaders( method, false ),

    body = JSON.stringify( data );

    return fetch( OPTION_DETAIL.replace( "<id>", id ), { method, headers, body } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const deleteCar = ( id ) => {

    let method = 'DELETE', headers = getHeaders( method, false );

    return fetch( CAR_DETAIL.replace( "<id>", id ), { method, headers } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const getOptionCategoryDetail = ( id ) => {

    let method = 'GET', headers = getHeaders( method, false );

    return fetch( OPTION_CATEGORY_DETAIL.replace( "<id>", id ), { method, headers } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const getOptionGroupDetail = ( id ) => {

    let method = 'GET', headers = getHeaders( method, false );

    return fetch( OPTION_GROUP_DETAIL.replace( "<id>", id ), { method, headers } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const getOptionDetail = ( id ) => {

    let method = 'GET', headers = getHeaders( method, false );

    return fetch( OPTION_DETAIL.replace( "<id>", id ), { method, headers } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const postConfiguration = ( title, car, imageBase64, data ) => {

    let method = 'POST', headers = getHeaders( method, false ),

    body = JSON.stringify( { title, car, imageBase64, data } );

    return fetch( CONFIGURATION_LIST, { method, headers, body } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const patchConfiguration = ( id, data ) => {

    let method = 'PATCH', headers = getHeaders( method, false ),

    body = JSON.stringify( data );

    return fetch( CONFIGURATION_DETAIL.replace( "<id>", id ), { method, headers, body } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const getConfigurationDetail = ( id, data ) => {

    let method = 'GET', headers = getHeaders( method, false ),

    body = JSON.stringify( data );

    return fetch( CONFIGURATION_DETAIL.replace( "<id>", id ), { method, headers, body } )
    .then( handleFetchResponse ).catch( handleFetchError );
}


export const deleteConfiguration = ( id ) => {

    let method = 'DELETE', headers = getHeaders( method, false );

    return fetch( CONFIGURATION_DETAIL.replace( "<id>", id ), { method, headers } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

//users
export const postUser = ( car_id, data ) => {

    let method = 'PATCH', headers = getHeaders( method, false ),

    body = JSON.stringify( { add_user: data } );

    return fetch( CAR_DETAIL.replace( "<id>", car_id ), { method, headers, body } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const patchUser = ( car_id, user_id, data ) => {

    let method = 'PATCH', headers = getHeaders( method, false ),

    body = JSON.stringify( data );

    return fetch( CAR_USER_DETAIL.replace( "<id>", car_id ).replace( "<user_id>", user_id ), { method, headers, body } )
    .then( handleFetchResponse ).catch( handleFetchError );
}

export const getUserDetail = ( car_id, user_id, data ) => {

    let method = 'GET', headers = getHeaders( method, false ),

    body = JSON.stringify( data );

    return fetch( CAR_USER_DETAIL.replace( "<id>", car_id ).replace( "<user_id>", user_id ), { method, headers, body } )
    .then( handleFetchResponse ).catch( handleFetchError );
}


export const deleteUser = ( car_id, user_id ) => {

    let method = 'DELETE', headers = getHeaders( method, false );

    return fetch( CAR_USER_DETAIL.replace( "<id>", car_id ).replace( "<user_id>", user_id ), { method, headers } )
    .then( handleFetchResponse ).catch( handleFetchError );
}